import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt, faUser } from "@fortawesome/free-solid-svg-icons";
import { useLanguage } from "./LanguageContext";
import "./Navigationbar.css";
import logo from "./logo.svg";

function Navigationbar() {
  const [scrolled, setScrolled]   = useState(false);
  const [menuOpen, setMenuOpen]   = useState(false);
  const { lang, t, toggleLang }   = useLanguage();
  const location                  = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Close menu on route change
  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  const isActive = (path) => location.pathname === path;

  return (
    <>
      {/* Dark overlay behind mobile menu */}
      <div
        className={`nav-overlay ${menuOpen ? "open" : ""}`}
        onClick={() => setMenuOpen(false)}
      />

      <header className={`site-header ${scrolled ? "header-scrolled" : ""}`}>
        <div className="nav-wrapper">

          {/* Logo */}
          <Link to="/" className="nav-logo">
            <img src={logo} alt="Hoope Logo" />
          </Link>

          {/* Right side: lang toggle + hamburger */}
          <div className="nav-right">
            {/* Language toggle with flags — always visible */}
            <button className="lang-toggle" onClick={toggleLang} aria-label="Sprache wechseln">
              <span className={`lang-flag ${lang === "de" ? "lang-flag--active" : ""}`} title="Deutsch">🇩🇪</span>
              <span className="lang-sep" />
              <span className={`lang-flag ${lang === "en" ? "lang-flag--active" : ""}`} title="English">🇬🇧</span>
            </button>

            {/* Hamburger button (mobile only) */}
            <button
              className={`hamburger ${menuOpen ? "open" : ""}`}
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Menü öffnen"
            >
              <span />
              <span />
              <span />
            </button>
          </div>

          {/* Navigation panel */}
          <nav className={menuOpen ? "open" : ""}>
            <ul>
              <li>
                <Link to="/" className={isActive("/") ? "active" : ""}>
                  {t.nav.home}
                </Link>
              </li>
              <li>
                <Link to="/skills" className={isActive("/skills") ? "active" : ""}>
                  {t.nav.skills}
                </Link>
              </li>
              <li>
                <Link to="/projects" className={isActive("/projects") ? "active" : ""}>
                  {t.nav.projects}
                </Link>
              </li>
              <li>
                <Link to="/contact" className={isActive("/contact") ? "active" : ""}>
                  {t.nav.contact}
                </Link>
              </li>
            </ul>

            {/* Contact info block – visible only in mobile menu */}
            <div className="nav-contact-block">
              <div className="nav-menu-divider" />

              <div className="nav-contact-item">
                <span className="nav-contact-icon">
                  <FontAwesomeIcon icon={faUser} />
                </span>
                <div>
                  <span className="nav-contact-label">{t.navContact.nameLabel}</span>
                  <span className="nav-contact-value">Abdul Wahhab Alfaghiri Al Anzi</span>
                </div>
              </div>

              <div className="nav-contact-item">
                <span className="nav-contact-icon">
                  <FontAwesomeIcon icon={faMapMarkerAlt} />
                </span>
                <div>
                  <span className="nav-contact-label">{t.navContact.addressLabel}</span>
                  <span className="nav-contact-value">5400 Hallein, Österreich</span>
                </div>
              </div>
            </div>
          </nav>

        </div>
      </header>
    </>
  );
}

export default Navigationbar;
